import { render } from "./VideoRectOutline.vue?vue&type=template&id=0bbed7db&scoped=true&ts=true"
import script from "./VideoRectOutline.vue?vue&type=script&lang=ts"
export * from "./VideoRectOutline.vue?vue&type=script&lang=ts"

import "./VideoRectOutline.vue?vue&type=style&index=0&id=0bbed7db&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbed7db"]])

export default __exports__